import React, { useState } from "react";

const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Sections", "Rooms", "Touch Switch"];

  return (
    <div className="w-full max-w-md">
      <div className="flex">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`flex-1 py-2 text-center rounded-t-lg ${
              activeTab === tab
                ? "bg-[#00428C] text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
